<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";

    let pageSize = 10; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];
    let interval;
    let isFetching = false;
    let initialLoading = true;

    onMount(() => {
        getData();

        interval = setInterval(getData, 10000); // 10초로 조정 (너무 빈번한 요청 방지)
    });

    onDestroy(() => {
        clearInterval(interval);
    });

    async function getData() {
        if (isFetching) return;
        isFetching = true;

        try {
            const response = await api.get(
                `/assignment?keyword=&page=1&sort=${decodeURI(
                    "a.created_at DESC",
                )}&cate=&usePageNavy=false`,
            );

            if (response != null) {
                // 데이터가 변경되었을 때만 업데이트
                if (
                    JSON.stringify(response.data) !== JSON.stringify(dataList)
                ) {
                    dataList = response.data;
                    currentPage = 0;
                    currentList = [];
                    loadMore();
                }
            }
        } catch (error) {
            console.error("Failed to fetch assignment data:", error);
        } finally {
            isFetching = false;
            initialLoading = false;
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }

    function formatPhoneNumber(num) {
        if (!num) return "";

        const digits = String(num).replace(/\D/g, "");

        if (digits.length === 10) {
            // 10자리: 3-3-4
            if (digits.startsWith("02")) {
                return digits.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
            }
            return digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else if (digits.length === 11) {
            // 11자리: 3-4-4
            return digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else {
            // 그 외는 그대로 출력
            return num;
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="as-wrapper">
    <div class="as-main">
        <header class="as-header">
            <div class="header-content">
                <h2>접수요청</h2>
                {#if !initialLoading}
                    <span class="count-badge">
                        {dataList.filter((d) => d.status == 2).length}
                    </span>
                {/if}
            </div>
        </header>

        <main class="as-list-container scroll-custom" on:scroll={handleScroll}>
            {#if initialLoading}
                <div class="state-container">
                    <div class="loader"></div>
                    <p>목록을 불러오고 있습니다...</p>
                </div>
            {:else}
                {@const filteredList = currentList.filter((d) => d.status == 2)}
                {#if filteredList.length > 0}
                    {#each filteredList as data, index}
                        <article class="as-card">
                            <div class="card-header-inner">
                                <div class="item-info">
                                    <span class="item-name">
                                        {data.item_name}
                                    </span>
                                    <span class="created-at">
                                        {data.created_at}
                                    </span>
                                </div>
                                <div class="status-tag">대기중</div>
                            </div>

                            <div class="card-body">
                                <div class="info-grid">
                                    <div class="info-item">
                                        <span class="info-label">접수처</span>
                                        <span class="info-value">
                                            {data.cus_name}
                                        </span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-label">수리처</span>
                                        <span class="info-value">
                                            {data.cus_name_rpr}
                                        </span>
                                    </div>
                                    <div
                                        class="info-item call-item"
                                        on:click|stopPropagation={() => {
                                            window.location.href = `tel:${data.phone}`;
                                        }}
                                    >
                                        <span class="info-label">
                                            연락처 (클릭 시 통화)
                                        </span>
                                        <span
                                            class="info-value highlight-phone"
                                        >
                                            📞 {formatPhoneNumber(data.phone)}
                                        </span>
                                    </div>
                                </div>

                                <div class="data-row addr-row">
                                    <span class="data-label">주소</span>
                                    <span class="data-value addr-val">
                                        {data.addr1}
                                        {data.addr2}
                                    </span>
                                </div>

                                <div class="data-row symptom-row">
                                    <span class="data-label">증상</span>
                                    <span class="data-value symptom-val">
                                        {#if data.symptom_cus}
                                            {data.symptom_cus.replaceAll(
                                                "<br>",
                                                "\n",
                                            )}
                                        {:else}
                                            <span class="no-data">
                                                입력된 증상 내용이 없습니다.
                                            </span>
                                        {/if}
                                    </span>
                                </div>
                            </div>

                            <div class="card-actions">
                                <button
                                    class="action-btn btn-primary"
                                    on:click={() => {
                                        push(`/AsForm/${data.as_id}`);
                                    }}
                                >
                                    작업 시작
                                </button>
                            </div>
                        </article>
                    {/each}
                {:else}
                    <div class="empty-state">
                        <div class="empty-icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="64"
                                height="64"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path
                                    d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                                ></path>
                                <path
                                    d="M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
                                ></path>
                            </svg>
                        </div>
                        <p class="empty-title">접수된 요청이 없습니다</p>
                        <p class="empty-desc">
                            새로운 접수 요청이 들어오면
                            <br />
                            이곳에 표시됩니다.
                        </p>
                    </div>
                {/if}
            {/if}
        </main>

        <div class="btm-wrap">
            <Btm />
        </div>
    </div>
</div>

<style>
    /* 
      Flexbox-based layout to cleanly adapt to Android font scaling.
      Uses global CSS variables for dark/light mode switching.
    */
    .as-wrapper {
        height: 100vh;
        height: 100dvh; /* dynamic vh for mobile Safari/Chrome */
        overflow: hidden; /* Prevent body scroll */
        background-color: var(--bg-color);
        transition: background-color 0.3s ease;
    }

    .as-main {
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 1024px;
        margin: 0 auto;
        height: 100%;
    }

    .as-header {
        flex-shrink: 0;
        background-color: var(--card-bg);
        border-bottom: 1px solid var(--border-color);
        padding: 12px 20px;
        text-align: center;
        transition:
            background-color 0.3s ease,
            border-color 0.3s ease;
        z-index: 10;
        box-shadow: var(--shadow-sm);
    }

    .header-content {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    .as-header h2 {
        color: var(--text-color);
        font-size: 1.15rem;
        font-weight: 700;
        margin: 0;
    }

    .count-badge {
        background-color: var(--primary-color);
        color: #ffffff;
        font-size: 0.8rem;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 12px;
        min-width: 20px;
    }

    /* main list container */
    .as-list-container {
        flex: 1;
        overflow-y: auto;
        padding: 16px 16px 20px; /* 하단 여백을 상단과 비슷하게 20px로 줄임 */
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    /* Cards */
    .as-card {
        background-color: var(--card-bg);
        border-radius: 16px;
        box-shadow: var(--shadow-md);
        border: 1px solid var(--border-color);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        flex-shrink: 0;
        animation: slideUp 0.4s ease-out;
    }

    .as-card:active {
        transform: scale(0.98);
    }

    .card-header-inner {
        padding: 16px 20px;
        background-color: var(--input-bg);
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--border-color);
    }

    .item-info {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .item-name {
        font-size: 1.25rem;
        font-weight: 800;
        color: var(--text-color);
    }

    .created-at {
        font-size: 0.9rem;
        color: var(--text-color);
        opacity: 0.6;
    }

    .status-tag {
        font-size: 0.85rem;
        font-weight: 700;
        background-color: var(--primary-color);
        color: #fff;
        padding: 4px 12px;
        border-radius: 6px;
    }

    .card-body {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .info-grid {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding-bottom: 12px;
        border-bottom: 1px dashed var(--border-color);
    }

    .info-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
    }

    .call-item {
        cursor: pointer;
        background-color: var(--input-bg);
        padding: 8px 12px;
        border-radius: 8px;
        border: 1px solid var(--border-color);
    }

    .highlight-phone {
        color: var(--primary-color);
        font-weight: 800;
        text-decoration: underline;
    }

    .info-label {
        font-size: 0.85rem;
        font-weight: 600;
        color: var(--text-color);
        opacity: 0.5;
    }

    .info-value {
        font-size: 1.05rem;
        font-weight: 700;
        color: var(--text-color);
    }

    /* Data rows inside card */
    .data-row {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .data-label {
        font-size: 0.85rem;
        font-weight: 600;
        color: var(--text-color);
        opacity: 0.5;
    }

    .data-value {
        font-size: 1.1rem;
        color: var(--text-color);
        font-weight: 500;
        line-height: 1.5;
        white-space: pre-wrap; /* 줄바꿈 복구 */
    }

    .addr-val {
        font-weight: 600;
    }

    .symptom-val {
        background-color: var(--input-bg);
        padding: 12px;
        border-radius: 8px;
        font-size: 1.05rem;
        color: var(--text-color);
        line-height: 1.5; /* 줄 간격 */
        max-height: 6.5rem; /* 요청하신 6.5rem으로 수정 */
        overflow-y: auto; /* 4줄 넘어가면 내부 스크롤 */
        white-space: pre-wrap; /* 줄바꿈 유지 */
        word-break: break-all;
    }

    .no-data {
        opacity: 0.4;
        font-style: italic;
        font-size: 0.95rem;
    }

    /* Actions */
    .card-actions {
        padding: 0 20px 20px;
    }

    .action-btn {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px;
        font-size: 1.15rem;
        font-weight: 800;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s;
        border: none;
    }

    .btn-primary {
        background-color: var(--primary-color);
        color: #fff;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
    }

    .state-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 40px 20px;
        color: var(--text-color);
        opacity: 0.6;
    }

    .loader {
        border: 3px solid var(--border-color);
        border-top: 3px solid var(--primary-color);
        border-radius: 50%;
        width: 30px;
        height: 30px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .btm-wrap {
        flex-shrink: 0;
        height: 70px;
        position: relative;
    }

    .no-data {
        opacity: 0.4;
        font-style: italic;
        font-size: 0.95rem;
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1;
        padding: 60px 20px;
        text-align: center;
        margin: auto 0;
    }

    .empty-icon {
        color: var(--text-color);
        opacity: 0.2;
        margin-bottom: 20px;
        animation: float 3s ease-in-out infinite;
    }

    .empty-title {
        font-size: 1.2rem;
        font-weight: 700;
        color: var(--text-color);
        margin: 0 0 8px 0;
        opacity: 0.8;
    }

    .empty-desc {
        font-size: 0.95rem;
        color: var(--text-color);
        opacity: 0.5;
        margin: 0;
        line-height: 1.5;
    }

    @keyframes float {
        0% {
            transform: translateY(0px);
        }
        50% {
            transform: translateY(-10px);
        }
        100% {
            transform: translateY(0px);
        }
    }
</style>
